
import { useTranslation } from "react-i18next";
import Main from "./Main";
import Sidebar from "./Sidebar";
import { useEffect } from "react";
function App() {
  const params = new URLSearchParams(window.location.search);
  const lang = params.get('lang') || null;
  const { i18n } = useTranslation();
  
  useEffect(() => {
    if (lang) {
      i18n.changeLanguage(lang);
    }
  }, []);

  return (
    <div className="container">
      <div className="content">
        <Sidebar />
        <Main />
      </div>
    </div>
  );
}

export default App;
